'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _DataTable = require('../DataTable');

var _DataTable2 = _interopRequireDefault(_DataTable);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hexColor = /^#[a-fA-F0-9]{6}$/;

/**
 *
 */

var Methods = function (_React$Component) {
	_inherits(Methods, _React$Component);

	function Methods(props) {
		_classCallCheck(this, Methods);

		var _this = _possibleConstructorReturn(this, (Methods.__proto__ || Object.getPrototypeOf(Methods)).call(this, props));

		_axwayReactIntl2.default.init(_this);
		_this._onExpand = _this._onExpand.bind(_this);
		return _this;
	}

	_createClass(Methods, [{
		key: '_onExpand',
		value: function _onExpand(item) {
			if (this.props.onExpand) {
				var methodString = item.method.toLowerCase();
				var ops = (0, _util.getOperations)(this.props.doc, item.path);
				var method = ops[methodString];
				return this.props.onExpand(method, methodString, item.path);
			}
			return null;
		}
	}, {
		key: 'convertHexToRgb',
		value: function convertHexToRgb(color) {
			// strip off #
			color = color.substring(1);
			var rgb = {};

			rgb.red = parseInt(color.substring(0, 2), 16);
			rgb.green = parseInt(color.substring(2, 4), 16);
			rgb.blue = parseInt(color.substring(4), 16);

			return rgb;
		}
	}, {
		key: 'getMethodStyle',
		value: function getMethodStyle(verb) {
			var _props = this.props,
			    hasMethodColors = _props.hasMethodColors,
			    methodColors = _props.methodColors;

			if (hasMethodColors && methodColors && methodColors[verb]) {
				var color = methodColors[verb];
				if (!hexColor.test(color)) {
					console.error('Method color (' + color + ') is not in the correct #000000 format');
					return;
				}
				var rgbColors = this.convertHexToRgb(color);
				var red = rgbColors.red,
				    green = rgbColors.green,
				    blue = rgbColors.blue;


				return {
					backgroundColor: 'rgba(' + red + ', ' + green + ', ' + blue + ', 0.2)'
				};
			}
		}
	}, {
		key: 'getMethodNameStyle',
		value: function getMethodNameStyle(verb) {
			var _props2 = this.props,
			    hasMethodColors = _props2.hasMethodColors,
			    methodColors = _props2.methodColors;

			if (hasMethodColors && methodColors && methodColors[verb]) {
				if (!hexColor.test(methodColors[verb])) {
					console.error('Method color (' + methodColors[verb] + ') is not in the correct #000000 format');
					return;
				}
				return { backgroundColor: methodColors[verb] };
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props3 = this.props,
			    doc = _props3.doc,
			    prefix = _props3.prefix,
			    expressPaths = _props3.expressPaths,
			    additionalColumns = _props3.additionalColumns,
			    hasMethodColors = _props3.hasMethodColors,
			    hiddenColumns = _props3.hiddenColumns;


			var methodStyle = function methodStyle(item) {
				return _this2.getMethodNameStyle(item.method.toLowerCase());
			};

			var columns = [{
				key: 'method',
				name: this.intl.formatMsg('Method'),
				className: 'method',
				style: methodStyle
			}, {
				key: 'abspath',
				name: this.intl.formatMsg('Path'),
				className: 'path nowrap ellipsis'
			}, {
				key: 'nickname',
				name: this.intl.formatMsg('Nickname'),
				className: 'nickname nowrap ellipsis'
			}, {
				key: 'description',
				name: this.intl.formatMsg('Description'),
				className: 'description nowrap ellipsis'
			}];
			columns = hiddenColumns.length ? columns.filter(function (column) {
				return !hiddenColumns.includes(column.key);
			}) : columns;
			columns = columns.concat(additionalColumns || []);
			var rows = [];
			if (doc.paths) {
				Object.keys(doc.paths).forEach(function (path) {
					if (/^x-/.test(path)) {
						// skip extensions
						return;
					}
					var operations = void 0;
					try {
						operations = (0, _util.getOperations)(doc, path);
					} catch (e) {
						console.error(e);
						return;
					}
					Object.keys(operations).forEach(function (verb) {
						if (verb === 'parameters' || /^x-/.test(verb)) {
							return;
						}
						var ep = operations[verb];
						var abspath = '' + (prefix || '') + path;
						if (expressPaths) {
							abspath = (0, _util.swaggerPathToExpress)(abspath);
						}

						rows.push({
							endpoint: ep,
							method: verb.toUpperCase(),
							className: verb.toLowerCase() + '-method',
							style: _this2.getMethodStyle(verb.toLowerCase()),
							path: path,
							abspath: abspath,
							nickname: ep.operationId || '',
							description: ep.summary || ep.description || ''
						});
					});
				});
			}

			return _react2.default.createElement(_DataTable2.default, {
				clickable: true,
				sortable: true,
				columns: columns,
				additionalColumnStyles: {
					collapsable: methodStyle
				},
				items: rows,
				expandedRowRender: this.props.onExpand && this._onExpand,
				className: (0, _classnames2.default)({ 'has-colors': hasMethodColors }),
				striped: !hasMethodColors
			});
		}
	}]);

	return Methods;
}(_react2.default.Component);

Methods.propTypes = {
	/**
  * Valid swagger 2.0 document
  */
	doc: _propTypes2.default.object.isRequired,

	/**
  * Include a prefix when rendering the method summary.  By default, there is no prefix.
  * If the method is "/foo", it will display "/foo".  If you want to include the basePath,
  * you must explicitly set it as the prefix. If speficied it must start with a leading slash.
  */
	prefix: function prefix(props, propName, componentName) {
		if (props[propName] === undefined || props[propName] === null) {
			return;
		}
		if (typeof props[propName] !== 'string') {
			return new Error('Invalid prop prefix supplied to' + (' `' + componentName + '`. prefix must be a string. Validation failed.'));
		} else if (props[propName][0] !== '/') {
			return new Error('Invalid prop prefix supplied to' + (' `' + componentName + '`. prefix must have a leading /. Validation failed.'));
		}
	},


	/**
  * Render Express style paths instead of Swagger style.
  */
	expressPaths: _propTypes2.default.bool,

	/**
  * Called when SwaggerUI first needs to render a method.
  */
	onExpand: _propTypes2.default.func,
	additionalColumns: _propTypes2.default.arrayOf(_propTypes2.default.object),
	/**
  * If true, the methods will be displayed with colored rows.
  */
	hasMethodColors: _propTypes2.default.bool,
	/**
  * Colors used for each row of Swagger methods.
  * This color will be displayed on the verb, and the rest of the row will
  * have a lighter version of this color. If no value is set, the default will be used.
  * Each key should be a lowercase method name, and each value
  * should be a hex color in the format '#ffffff'.
  * This is only applied when hasMethodColors is true.
  */
	methodColors: _propTypes2.default.object,
	/**
  * Hidden columns for the methods.
  * They are provided as array of strings.
  */
	hiddenColumns: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Methods.defaultProps = {
	expressPaths: false,
	hasMethodColors: false,
	methodColors: {},
	hiddenColumns: []
};

var _default = (0, _reactIntl.injectIntl)(Methods);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(hexColor, 'hexColor', 'src/components/SwaggerUI/Methods.jsx');

	__REACT_HOT_LOADER__.register(Methods, 'Methods', 'src/components/SwaggerUI/Methods.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/SwaggerUI/Methods.jsx');
}();

;